import {ChangeDetectionStrategy, Component, inject} from '@angular/core';

import {CookieService} from 'ngx-cookie-service';
import {environment} from 'src/environments/environment';

@Component({
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [],
    templateUrl: './resident-app.component.html',
    styleUrl: './resident-app.component.scss',
})
export class ResidentAppComponent {
    private readonly cookieService = inject(CookieService);

    constructor() {
        // When the user has been fetched, an authentication token must have been saved in
        // local storage. We also set the token as a cookie for backwards compatability with
        // react frontend.
        const token = this.cookieService.check('access_token')
            ? this.cookieService.get('access_token')
            : null;
        if (token != null) {
            this.cookieService.set('token', token, {
                path: '/',
                expires: 1 / 24, // Expires in one hour
            });
            window.location.replace(`${environment.reactOnlineUrl}/consumption-overview`);
        }
    }
}
